import { useEffect, useState } from 'react'
import { View, Text, Image } from 'react-native'
import NetInfo from '@react-native-community/netinfo' // mobile
import theme from '../../../../theme'
import { isWeb } from '@/utils/platformUtils'

export const NoConnectionVideo = () => {
    return (
        <View
            style={{
                // flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#F1F2FF',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            }}
        >
            <Image source={require('../../../../assets/noVideo.png')} style={{ width: 112, height: 112, marginBottom: 8 }} />

            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '65%' }}>
                <Image
                    source={require('../../../../assets/warningCircle.png')}
                    style={{ width: 32, height: 32, tintColor: theme.colors.colorPrimary }}
                />
                <View style={{ marginStart: 10 }}>
                    <Text style={{ color: theme.colors.colorPrimary, fontWeight: '700', fontSize: 16 }}>No disponible sin conexión</Text>
                    <Text style={{ color: theme.colors.colorPrimary, fontSize: 14, marginTop: 4 }}>
                        Conéctate a internet para reproducir este contenido.
                    </Text>
                </View>
            </View>
        </View>
    )
}

export const useNoConnectionVideoModal = ({ videoError, videoLoaded, setVideoError, setRetryKey }) => {
    const [isOffline, setIsOffline] = useState(false)
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        NetInfo.fetch().then((state) => {
            const offline = !(state.isConnected && state.isInternetReachable)
            setIsOffline(offline)
        })

        const unsub = NetInfo.addEventListener((state) => {
            const offline = !(state.isConnected && state.isInternetReachable)
            setIsOffline(offline)
        })

        return () => unsub()
    }, [])

    useEffect(() => {
        // Si ya cargó o dio error → no hacer nada
        if (videoLoaded || videoError) return

        // Timeout de 2.5 segundos (ajustable)
        const timeout = setTimeout(() => {
            if (!videoLoaded && !videoError && isOffline) {
                // No disparó nada + offline = mostrar modal
                setShowModal(true)
            }
        }, 2500)

        return () => clearTimeout(timeout)
    }, [videoLoaded, videoError, isOffline])

    // Mostrar el modal solo cuando:
    // 1) No cargó el video
    // 2) Hubo error o nunca se cargó
    // 3) Estás offline
    // 4) No hay caché (videoLoaded === false)

    useEffect(() => {
        // Si vuelve la conexión → ocultamos modal
        if (!isOffline) {
            setShowModal(false)
        }

        // Si hubo error, estás offline y NO cargó → mostrar modal
        if (isOffline && videoError && !videoLoaded) {
            setShowModal(true)
        }
    }, [isOffline, videoError, videoLoaded])

    useEffect(() => {
        if (!isOffline && videoError && !videoLoaded) {
            // Forzar recarga del video
            setRetryKey((prev) => prev + 1)

            // Resetear error para que pueda fallar de nuevo si pasa
            setVideoError(false)
        }
    }, [isOffline])

    return showModal
}
